// Tile markup.  
var productCardMarkup = `<div id="shared-wishlist-list">
<h1>A friend shared their favorites list</h1>
		<div class="swym-widget swym-products swym-products-grid" id="swym-widget-shared-{{hkey}}">
			<ul class="swym-products-loop favorites" id="shared-wishlist-grid">
				<li style="list-style: none">{{#productArray}}</li>
				<li class="swym-product-grid-li favourite">
					<div class="swym-product-grid-item">
						<div class="swym-product-grid-overlay"></div><a class="swym-product-grid-hyperlink" href="{{uri}}" title="{{title}}">
						<div class="swym-product-grid-meta"></div>
						<div class="swym-product-grid-image image">
							<div class="swym-product-grid-image-placeholder">
								<span class="swym-v-align-outer"><span class="swym-v-align-inner"><img alt="{{title}}" itemprop="image" src="{{iu}}"></span></span>
							</div>
						</div>
						<div class="swym-product-grid-info">
							<h2>{{title}}</h2> <span></span>
						</div>
						<div class="swym-product-grid-price price">
							<span class="swym-pr">{{cu}}{{pr}}</span>
						</div>
						<div class="buttons">
							<div class="add-to-cart button orange full" name="add" id="add" data-variant-id="{{epi}}">Buy Me</div>
						</div>
						</a>
						
						<div class="swym-product-grid-actions"></div>
					</div>
				</li>
				<li style="list-style: none">{{/productArray}}</li>
			</ul>
		</div>
	</div>
`;

function fetchSharedWishlistProducts() {
	//   Get the Hkey
	var userHkey = SwymUtils.getParameterByName("hkey");
	if (userHkey && userHkey.length > 0 && userHkey.trim() !== "") {
		_swat.sharedWlApi.fetch({
			params: {
				hkey: userHkey
			},
			scb: function(res) {
				renderWishlistUI(res.queryres, userHkey);
			},
			fcb: function() {
				SwymUtils.error("Error fetching shared wishlisted Products", arguments);
				errorCallback(null);
			}
		});
	}
}
// Render the Products in the User Interface.
function renderWishlistUI(products, userHkey) {
	//fetch the container.
	var wishlistContentsContainer = document.getElementById("wishlist-items-container");
	//   format products if required
	var formattedWishlistedProducts = products.map(function(p) {
		p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
		return p;
	});
	// final shared products output.   
	var sharedProducts = {
		productArray: formattedWishlistedProducts,	hkey: userHkey
	};
	//render the page using mustache.
	var productCardsMarkup = Mustache.render(productCardMarkup, sharedProducts);
	wishlistContentsContainer.innerHTML = productCardsMarkup;
};

function errorCallbackFn() {
	//   your error callback.
	console.log("error, rendering shared wishlisted products");
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(fetchSharedWishlistProducts);
